export default __webpack_public_path__ + "static/media/blazor.80bf5d47.svg";